'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class ConfirmacionBaja extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { numeroCuenta, saldoTotal, executionContext, bajaId } = this.props;
        const registroBaja = saldoTotal == 0 ? <p>Se registró exitosamente la solicitud de baja y se procederá a realizar el cierre definitivo de cuenta.</p> :
            <p>Se registró exitosamente la solicitud de baja. <strong>La Baja definitiva se concretará cuando la cuenta no presente saldo.</strong></p>

        const timeToNovedad = new Date().toISOString().replace("T", " ").replace("Z", "");
        const fecha = timeToNovedad.substring(0, 10).split("-");
        const hora = timeToNovedad.substring(16, 11);

        return <div className="container-fluid saldos-resumenes">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6 left-separator-xs">
                            {registroBaja}
                        </div>
                        <div className="col-md-1">
                            &nbsp;
                        </div>
                        <div className="col-md-4">
                            <label className="label-titulo">Registro de Baja</label>
                            <br />
                            <label className="label-titulo left-separator-lg">
                                <strong> N° {bajaId} </strong>
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 left-separator-xs">
                            <span className="icon-ti-user-icon-persona-cyan"></span>
                            <label className="label-primary">Baja: {fecha[2] + "-" + fecha[1]} a las {hora} por {executionContext.login} </label>
                        </div>
                        <div className="col-md-5">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default ConfirmacionBaja;